import { render, staticRenderFns } from "./religiousBackgroundEdit.vue?vue&type=template&id=b8aecf6c"
import script from "./religiousBackgroundEdit.vue?vue&type=script&lang=js"
export * from "./religiousBackgroundEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports